import { SWRConfig } from "swr";
import { usePostHog } from "posthog-js/react";

import { ApiException } from "common/middleware/api.services";

export const SWRGlobalConfig = function SWRGlobalConfig({ children }: { children: React.ReactNode }) {
  const posthog = usePostHog();

  return (
    <SWRConfig value={{
      errorRetryCount: 1,
      onError: async (error) => {
        if (process.env.NODE_ENV === "development") return;

        if (error instanceof ApiException) {
          if (error.status === 401) return;

          posthog?.captureException(error, {
            api_status: error.status,
            api_message: error.message,
            api_response: error.response,
          });
          return;
        }

        posthog?.captureException(error);
      },
    }}>
      {children}
    </SWRConfig>
  );
};
